var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoJustText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1242.1 255.5",
    style: {
      enableBackground: "new 0 0 1242.1 255.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#0A80FE;}\r\n\t.st2{fill:#0A80FE;}\r\n\t.st3{fill:#FE720A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-95.5,77.8c-35.8,0-70.7,0-105.9,0c0-15.3,0-30,0-45c50.2,0,100.1,0,150.5,0c0,39.5,0,79.1,0,119.1 c-14.6,0-29.3,0-44.6,0C-95.5,127.4-95.5,103.1-95.5,77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-271.3,32.7c18.2,0,36.1,0,54.2,0c0,15,0,29.7,0,44.7c-18.2,0-36,0-54.2,0C-271.3,62.7-271.3,47.9-271.3,32.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-286.8,32.9c0,15,0,29.6,0,44.6c-17.9,0-35.6,0-53.8,0c0-14.7,0-29.4,0-44.6 C-322.9,32.9-305.1,32.9-286.8,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-95.6,221.5c0-18,0-35.6,0-53.6c14.9,0,29.7,0,44.8,0c0,17.8,0,35.5,0,53.6 C-65.6,221.5-80.3,221.5-95.6,221.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.5,201v-14.4c-9,10.8-26.3,17.9-44.9,17.9C27.5,204.6,0,189.6,0,157c0-35,27.5-46.4,49.7-46.4 c19.1,0,36.2,6,44.9,16.8v-17.3c0-12.6-10.8-20.9-29.3-20.9c-14.4,0-29.3,5.4-41,15.2l-16.5-29c18.5-15.8,43.4-22.4,65.5-22.4 c34.7,0,67.3,12.9,67.3,57.7V201L94.5,201L94.5,201z M94.5,163.9V151c-4.8-6.6-15.6-10.2-25.7-10.2c-12.3,0-23,5.4-23,16.8 c0,11.4,10.8,16.8,23,16.8C79,174.4,89.7,170.8,94.5,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.5,182.5l19.1-31.7c10.8,9.6,33.8,19.1,50.8,19.1c13.8,0,19.4-4.5,19.4-11.1c0-18.8-84.1-0.3-84.1-58.3 c0-25.4,21.8-47.6,61.9-47.6c24.2,0,44.9,7.8,60.4,19.1l-17.6,30.5c-8.7-8.4-25.1-15.8-42.5-15.8c-10.8,0-18.2,4.5-18.2,10.5 c0,16.8,84.1,0.3,84.1,59.5c0,27.5-24.2,47.9-65.8,47.9C200.4,204.6,173.8,195.9,158.5,182.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M401.1,52.9c-16.5,0-31.4,6.6-42.8,20.3V56.5h-46.1v195.8h46.1v-68.4c12,14.4,26.6,20.6,42.8,20.6 c36.2,0,63.4-26.9,63.4-76C464.5,79.9,437.3,52.9,401.1,52.9z M385.8,163.9c-9.9,0-21.8-5.7-27.5-13.2v-44 C364,99,376,93.6,385.8,93.6c18,0,31.7,13.4,31.7,35C417.5,150.5,403.8,163.9,385.8,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M570.4,201v-14.4c-9,10.8-26.3,17.9-44.9,17.9c-22.1,0-49.7-15-49.7-47.6c0-35,27.5-46.4,49.7-46.4 c19.1,0,36.2,6,44.9,16.8v-17.3c0-12.6-10.8-20.9-29.3-20.9c-14.4,0-29.3,5.4-41,15.2l-16.5-29c18.5-15.8,43.4-22.4,65.5-22.4 c34.7,0,67.3,12.9,67.3,57.7V201L570.4,201L570.4,201z M570.4,163.9V151c-4.8-6.6-15.5-10.2-25.7-10.2c-12.3,0-23,5.4-23,16.8 c0,11.4,10.8,16.8,23,16.8C554.8,174.4,565.6,170.8,570.4,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M634.4,182.5l19.1-31.7c10.8,9.6,33.8,19.1,50.8,19.1c13.8,0,19.4-4.5,19.4-11.1c0-18.8-84-0.3-84-58.3 c0-25.4,21.8-47.6,61.9-47.6c24.2,0,44.9,7.8,60.4,19.1l-17.6,30.5c-8.7-8.4-25.1-15.8-42.5-15.8c-10.8,0-18.2,4.5-18.2,10.5 c0,16.8,84,0.3,84,59.5c0,27.5-24.2,47.9-65.8,47.9C676.3,204.6,649.7,195.9,634.4,182.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M877.4,122.7l53.2-65.8H875l-43.2,56.7l-0.7,1V1.8h-45.3v199.5H831v-34.7l0.7-0.9l13-15.6l31.7,51.1h56.8 L877.4,122.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M942.4,128.9c0-41.9,31.7-75.7,76.9-75.7c42.8,0,73.9,31.4,73.9,80.5v9.9H990.3c2.7,13.5,15.2,25.7,36.2,25.7 c10.2,0,27.8-4.5,35.9-12.3l19.4,28.7c-14.4,12.9-38.3,19.1-60.4,19.1C976.8,204.9,942.4,175.9,942.4,128.9z M1019.3,88.9 c-20,0-27.8,14.4-29.6,24.8h59.5C1048,103.5,1040.5,88.9,1019.3,88.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1108.7,182.8l19.1-31.7c10.8,9.6,33.8,19.1,50.8,19.1c13.8,0,19.4-4.5,19.4-11.1c0-18.8-84-0.3-84-58.3 c0-25.4,21.8-47.6,61.9-47.6c24.2,0,44.9,7.8,60.4,19.1l-17.7,30.5c-8.7-8.4-25.1-15.9-42.5-15.9c-10.8,0-18.2,4.5-18.2,10.5 c0,16.8,84,0.3,84,59.5c0,27.5-24.2,47.9-65.8,47.9C1150.6,204.9,1124,196.2,1108.7,182.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJustText);
export default __webpack_public_path__ + "static/media/logo-just-text.a00dc30833c17ccafca6445070289069.svg";
export { ForwardRef as ReactComponent };